<template>
  <div
    :class="['stake-row clickable', { 'has-divider': hasDivider }]"
    @click="
      $router.push({
        path: '/stake/' + dataItem.projectName,
      })
    "
  >
    <div class="d-flex text-5 font-weight-medium align-center pa-6 rounded-24">
      <div class="flex-2 d-flex align-center">
        <img :src="dataItem.icon" alt="" height="36" width="36" />
        <div class="ml-5">
          <div class="text-uppercase">{{ dataItem.token }}</div>
          <div class="text-6 gray--text mt-2">{{ dataItem.name }}</div>
        </div>
      </div>
      <div class="flex-2 text-right">
        <div>${{ dataItem.totalStakedAUM | numberFormat("0,0.00") }}</div>
      </div>
      <div class="flex-2 text-right">
        <div v-if="!rewardsAutocompounded[dataItem.token]">
          ${{ dataItem.rewards | numberFormat("0,0.00") }}
        </div>
        <div v-else class="gray--text text-6">
          Rewards are <br />
          auto-compounded
        </div>
      </div>
      <div class="flex-2 text-right">
        <div v-if="dataItem.market.name === 'Tendermint'">
          ${{ dataItem.unbonding | numberFormat("0,0.00") }}
        </div>
        <div v-else class="gray--text text-6">{{ "N/A" }}</div>
      </div>
      <div class="flex-1 text-right">
        <v-tooltip bottom color="dark">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <img
                :src="dataItem.market.logo"
                height="20"
                width="20"
                :alt="dataItem.market.name"
              />
            </span>
          </template>
          <span>{{ dataItem.market.name }}</span>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataItem: Object,
    hasDivider: Boolean,
  },
  data: () => ({
    rewardsAutocompounded: {
      knc: true,
      grt: true,
    },
  }),
};
</script>

<style lang="scss" scoped>
.stake-row {
  &.has-divider {
    border-top: 1px solid #e3f9ed;
  }
}
</style>
